export default __webpack_public_path__ + "static/media/SA.8aec8aea.svg";